module.exports = __webpack_public_path__ + "img/img47.a9e6acc1.png";